import {
	ContentContainer,
	ContentBox,
	ContentTitle,
	ContentWrapper,
	ImageBox,
	ContentDesctiptionBonus
} from './ContentStyled';

export default function Bonus({ dimentions, text, arr, title, className }) {
	return (
		<ContentWrapper scale={dimentions.scale}>
			<ContentContainer>
				<div style={{ margin: 'auto' }}>
					<ContentTitle scale={dimentions.scale}>{title}</ContentTitle>
					<ContentDesctiptionBonus scale={dimentions.scale}>
						{text[0]}
					</ContentDesctiptionBonus>
				</div>
			</ContentContainer>
			<ContentBox style={{ gap: '1vw' }}>
				{Array(arr.length)
					.fill()
					.map((_, id) => (
						<ImageBox key={id} className={className}>
							<img src={arr[id]} alt='img' />
						</ImageBox>
					))}
			</ContentBox>
			<br />
			<div style={{ margin: 'auto' }}>
				<ContentDesctiptionBonus scale={dimentions.scale}>
					{text[1]}
				</ContentDesctiptionBonus>
			</div>
		</ContentWrapper>
	);
}
